var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88883 1.11108C9.50248 1.11108 9.99995 1.60855 9.99995 2.2222V3.33331H16.6666V2.2222C16.6666 1.60855 17.1641 1.11108 17.7777 1.11108C18.3914 1.11108 18.8888 1.60855 18.8888 2.2222V3.33331H19.9999C22.4545 3.33331 24.4444 5.32315 24.4444 7.77775V20C24.4444 22.4546 22.4545 24.4444 19.9999 24.4444H6.66661C4.21201 24.4444 2.22217 22.4546 2.22217 20V7.77775C2.22217 5.32315 4.21201 3.33331 6.66661 3.33331H7.77772V2.2222C7.77772 1.60855 8.27519 1.11108 8.88883 1.11108ZM16.6666 5.55553C16.6666 6.16918 17.1641 6.66664 17.7777 6.66664C18.3914 6.66664 18.8888 6.16918 18.8888 5.55553H19.9999C21.2272 5.55553 22.2222 6.55045 22.2222 7.77775V8.33331H4.44439V7.77775C4.44439 6.55045 5.43931 5.55553 6.66661 5.55553H7.77772C7.77772 6.16918 8.27519 6.66664 8.88883 6.66664C9.50248 6.66664 9.99995 6.16918 9.99995 5.55553H16.6666ZM22.2222 10.5555H4.44439V20C4.44439 21.2273 5.43931 22.2222 6.66661 22.2222H19.9999C21.2272 22.2222 22.2222 21.2273 22.2222 20V10.5555Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.672e6b0336874ae9d0ebda540ab25337.svg";
export { ForwardRef as ReactComponent };